import React from 'react';
import { FileText, Calendar, CheckCircle, UserCheck, Clock } from 'lucide-react';
import { IntelligenceProfile } from '../../types';

interface OperationsSectionProps {
  profile: IntelligenceProfile;
  className?: string;
}

export const OperationsSection: React.FC<OperationsSectionProps> = ({
  profile,
  className = ""
}) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className={`p-3 bg-gray-50 rounded-lg border-l-4 border-l-gray-400 ${className}`}>
      <h4 className="text-sm font-semibold text-gray-900 mb-3 flex items-center">
        <FileText className="h-4 w-4 mr-2" />
        Operations
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <p className="text-xs text-gray-700 mb-1">Tracking ID</p>
          <p className="font-mono text-sm bg-blue-50 text-blue-700 px-2 py-1 rounded border border-blue-200">
            {profile.tracking_id}
          </p>
        </div>
        <div>
          <p className="text-xs text-gray-700 mb-1">Created Date</p>
          <p className="text-sm flex items-center text-gray-900">
            <Calendar className="h-4 w-4 mr-1" />
            {formatDate(profile.created_at)}
          </p>
        </div>
        <div>
          <p className="text-xs text-gray-700 mb-2">Status Details</p>
          {profile.submission ? (
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full border border-green-300 flex items-center">
                  <CheckCircle className="h-3 w-3 mr-1" />
                  Submitted
                </span>
                <span className="text-xs text-gray-600 font-mono">
                  {formatDate(profile.submission.submitted_at)}
                </span>
              </div>
              {profile.submission.assigned_consultant && (
                <div className="flex items-center gap-2">
                  <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full border border-blue-300 flex items-center">
                    <UserCheck className="h-3 w-3 mr-1" />
                    Consultant
                  </span>
                  <span className="text-xs text-gray-700 font-medium">
                    {profile.submission.assigned_consultant}
                  </span>
                </div>
              )}
            </div>
          ) : (
            <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full border border-gray-300 flex items-center w-fit">
              <Clock className="h-3 w-3 mr-1" />
              Not submitted
            </span>
          )}
        </div>
      </div>
    </div>
  );
};